export default __webpack_public_path__ + "static/media/Mike.6751efac.png";